import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {
  ConfiguratorEndpointInterceptor,
  CpsCampaignTrackingInterceptor,
  DCPConfiguratorCartService,
  DCPConfiguratorRouterExtractorService,
  DcpConfiguratorCommonsService
} from '@dcp/configurator';
import {AuthGuard, ConfigModule, I18nModule, OccConfig} from '@spartacus/core';
import {ConfiguratorRouterExtractorService} from '@spartacus/product-configurator/common';
import {ConfiguratorCartService, ConfiguratorCommonsService} from '@spartacus/product-configurator/rulebased';
import {CmsPageGuard} from '@spartacus/storefront';
import {NgDesignSystemModule} from 'ng-design-system';
import {CartEditModule} from '@app/cart/edit-cart/cart-edit.module';
import {
  MultiCurrencyCartErrorModule
} from '@app/checkout/error-handling/multi-currency-cart-error/multi-currency-cart-error.module';
import {ContactCtaModule} from '@app/contact-cta/contact-cta.module';
import {ConfiguratorComponentsModule} from './configurator-components/configurator-components.module';
import {ConfiguratorComponent} from './configurator.component';
import {ConfigureServiceErrorModule} from './error-handling/configure-service-error/configure-service-error.module';
import {ConfigureUrlErrorComponent} from './error-handling/configure-url-error/configure-url-error.component';
import {ConfigureUrlErrorModule} from './error-handling/configure-url-error/configure-url-error.module';
import {
  DefaultConfiguratorErrorComponent
} from './error-handling/default-configurator-error/default-configurator-error.component';
import {NetNewModule} from './error-handling/net-new/net-new.module';

@NgModule({
  declarations: [
    ConfiguratorComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductConfiguratorComponent: {
          component: ConfiguratorComponent,
        }
      }
    }),
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            createVariantConfiguration: 'products/${productCode}/configurators/ccpconfigurator?provideAllAttributes=true',
          },
        }
      }
    } as OccConfig),
    ConfiguratorComponentsModule,
    CartEditModule,
    MultiCurrencyCartErrorModule,
    I18nModule,
    NgDesignSystemModule,
    ContactCtaModule,
    ConfigureServiceErrorModule,
    ConfigureUrlErrorModule,
    NetNewModule,
    RouterModule.forChild([
      {
        data: {
          cxRoute: 'configuratorError',
        },
        path: 'configurator/error/:errorCode',
        component: ConfigureUrlErrorComponent,
        canActivate: [AuthGuard, CmsPageGuard]
      },
      {
        data: {
          cxRoute: 'configuratorErrorDefault',
        },
        path: 'configurator/error',
        component: DefaultConfiguratorErrorComponent,
        canActivate: [AuthGuard, CmsPageGuard]
      },
    ]),
  ],
  exports: [
    ConfiguratorComponent,
    RouterModule
  ],
  providers: [
    {
      provide: ConfiguratorCartService,
      useClass: DCPConfiguratorCartService
    },
    {
      provide: ConfiguratorRouterExtractorService,
      useClass: DCPConfiguratorRouterExtractorService
    },
    {
      provide: ConfiguratorCommonsService,
      useClass: DcpConfiguratorCommonsService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConfiguratorEndpointInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CpsCampaignTrackingInterceptor,
      multi: true
    },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ConfiguratorModule {
}
